import PropTypes from "prop-types";
import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";

const AccessKeyOverlay = ({ onAccessGranted, loading }) => {
    const [input, setInput] = useState("");
    const handleSubmit = (e) => {
        e.preventDefault();
        onAccessGranted(input);
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center"
            style={{
                background:
                    "var(--navy) url('/images/aqi-logo-white.png') no-repeat center 20%/180px, var(--navy)",
            }}
        >
            <div
                className="absolute inset-0"
                style={{
                    background: "linear-gradient(to bottom, var(--navy), #C2D7E2)",
                    opacity: 0.7,
                }}
            ></div>
            <form
                onSubmit={handleSubmit}
                className="relative z-10 flex flex-col items-center justify-center bg-white bg-opacity-95 rounded-2xl shadow-2xl px-10 pt-4 pb-12 min-w-[340px] max-w-sm w-full border border-[#C2D7E2]"
            >
                <img
                    src="/images/AeQuitas-Logo-blue-with-text.png"
                    alt="AeQuitas Logo"
                    className="mb-8 w-36 h-18 object-contain drop-shadow-lg"
                    style={{ borderRadius: 12, padding: 10 }}
                />
                <h2 className="text-3xl font-bold text-navy mb-3 tracking-tight">
                    ACCESS REQUIRED
                </h2>

                <p
                    className="text-navy mb-6 text-center text-base font-medium"
                    style={{ whiteSpace: "nowrap" }}
                >
                    Enter your access key to unlock the demo site.
                </p>
                <input
                    type="password"
                    className="w-full px-5 py-3 mb-4 border-2 border-[#C2D7E2] rounded-xl focus:outline-none focus:ring-2 focus:ring-navy text-navy bg-[#EAF3F7] placeholder-navy font-semibold text-lg shadow-sm transition"
                    placeholder="Access Key"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    autoFocus
                    disabled={loading}
                />
                <button
                    type="submit"
                    className="w-full py-3 mt-2 bg-navy text-white font-bold rounded-xl hover:bg-navy-2 transition-colors text-lg shadow-md"
                    disabled={loading}
                >
                    {loading ? (
                        <span className="flex items-center justify-center">
                            <CgSpinner className="animate-spin h-5 w-5 mr-2 text-white" />
                            Checking...
                        </span>
                    ) : (
                        "Unlock"
                    )}
                </button>
                <div
                    className="mt-6 text-xs text-navy text-center opacity-70 font-medium"
                    style={{ whiteSpace: "nowrap" }}
                >
                    Access is restricted. Please contact AQI for your demo key.
                </div>
            </form>
        </div>
    );
};

AccessKeyOverlay.propTypes = {
    onAccessGranted: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default AccessKeyOverlay;
